export default __webpack_public_path__ + "static/media/factionless_1.fa7149bb.webp";